import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import LanguagePage from './pages/LanguagePage';
import LandingPage from './pages/LandingPage';
import OverQuotaUsersPage from './pages/OverQuotaUsersPage';
import ReassignQuotaUsersPage from './pages/ReassignQuotaUsersPage';

export default function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/language" element={<LanguagePage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/over-quota-users" element={<OverQuotaUsersPage />} />
        <Route path="/reassign-quota" element={<ReassignQuotaUsersPage />} />
      </Routes>
    </BrowserRouter>
  );
}
